import { render, staticRenderFns } from "./StarFill.vue?vue&type=template&id=62c3229d&scoped=true&"
import script from "./StarFill.vue?vue&type=script&lang=js&"
export * from "./StarFill.vue?vue&type=script&lang=js&"
import style0 from "./StarFill.vue?vue&type=style&index=0&id=62c3229d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c3229d",
  null
  
)

export default component.exports